<mat-card appearance="outlined" telemetry="Card-NewPacketLaunch-UtilityBilling">

    <mat-card-header>
        <mat-card-title>New Packet Launch</mat-card-title>
    </mat-card-header>

    <mat-card-content fxLayout="column">

        <div *ngIf="!hasItems" fxFlex fxLayoutAlign="center">
            You have no New Packet Templates
        </div>

        <ng-container *ngIf="hasItems">
            <!--
            <div *ngFor="let item of displayItems" fxLayout="row" fxLayoutAlign="space-between center" class="row">
                <div fxFlex="20" class="module">{{item.Module}}</div>
                <div fxFlex="25" class="not-module">{{item.Process}}</div>
                <div fxFlex="35" class="not-module">{{item.Description}}</div>

                <button mat-icon-button fxFlex="8" (click)="launch(item)" [disabled]="isSaving" matTooltip="Launch"
                        [attr.telemetry]="getLaunchAriaLabel(item)">
                    <mat-icon fontIcon="play_arrow" fontSet="material-icons">
                    </mat-icon>
                </button>

                <button mat-icon-button fxFlex="8" (click)="newPacketTemplate(item)" [disabled]="isSaving"
                        matTooltip="Edit" [attr.telemetry]="getEditAriaLabel(item)">
                    <mat-icon fontIcon="mode_edit" fontSet="material-icons">
                    </mat-icon>
                </button>

                <button mat-icon-button fxFlex="8" (click)="delete(item)" [disabled]="isSaving" matTooltip="Delete"
                        [attr.telemetry]="getDeleteAriaLabel(item)">
                    <mat-icon fontIcon="delete" fontSet="material-icons">
                    </mat-icon>
                </button>
            </div>
            -->

            <table mat-table [dataSource]="tableData" fxFill>
                <ng-container matColumnDef="module">
                    <th mat-header-cell *matHeaderCellDef>Module</th>
                    <td mat-cell *matCellDef="let row"> {{row.Module}} </td>
                </ng-container>

                <ng-container matColumnDef="process">
                    <th mat-header-cell *matHeaderCellDef>Process</th>
                    <td mat-cell *matCellDef="let row">{{row.Process}}</td>
                </ng-container>

                <ng-container matColumnDef="description">
                    <th mat-header-cell *matHeaderCellDef>Description</th>
                    <td mat-cell *matCellDef="let row">{{row.Description}}</td>
                </ng-container>

                <ng-container matColumnDef="launch">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let row">
                        <button mat-icon-button (click)="launch(row)" [disabled]="isSaving" matTooltip="Launch" [attr.aria-label]="getLaunchAriaLabel(row)" [attr.telemetry]="getLaunchAriaLabel(row)" style="padding: 0px;">
                            <mat-icon>play_arrow</mat-icon>
                        </button>
                    </td>
                </ng-container>

                <ng-container matColumnDef="edit">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let row">
                        <button mat-icon-button (click)="newPacketTemplate(row)" [disabled]="isSaving" matTooltip="Edit" [attr.aria-label]="getEditAriaLabel(row)" [attr.telemetry]="getEditAriaLabel(row)" style="padding: 0px;">
                            <mat-icon>mode_edit</mat-icon>
                        </button>
                    </td>
                </ng-container>

                <ng-container matColumnDef="delete">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let row">
                        <button mat-icon-button (click)="delete(row)" [disabled]="isSaving" matTooltip="Delete" [attr.aria-label]="getDeleteAriaLabel(row)" [attr.telemetry]="getDeleteAriaLabel(row)" style="padding: 0px;">
                            <mat-icon>delete</mat-icon>
                        </button>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="columnNames"></tr>
                <tr mat-row *matRowDef="let myRowData; columns: columnNames"></tr>
            </table>

            <div *ngIf="canShowMore">
                <mat-divider></mat-divider>
                <button mat-icon-button (click)="showMore($event)" class="fs32">
                    <mat-icon>more_horiz</mat-icon>
                </button>
            </div>
        </ng-container>

        <mat-progress-bar *ngIf="isSaving" mode="indeterminate"></mat-progress-bar>

    </mat-card-content>

    <mat-card-actions fxLayout="row" fxLayoutAlign="end center">
        <button mat-fab color="primary" (click)="newPacketTemplate()" matTooltip="Add New Template" telemetry="Submission-Add-NewTemplate-UtilityBilling">
            <mat-icon fontIcon="add"></mat-icon>
        </button>
    </mat-card-actions>

</mat-card>